import ApiService from "@/utils/api.service";
export default {
    getAlbum(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("album/" + params)
                .then(({ data }) => {
                    context.commit("setAlbum", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    selectImage(context, imageId) {
        context.commit("selectImage", imageId);
    },
    unselectImage(context, imageId) {
        context.commit("unselectImage", imageId);
    },
    sendSelection(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("album/" + params + "/send-selection", { selected: context.state.selected })
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    }
}